import React from 'react';
import { Page, Document, View, Text, PDFViewer, Image } from '@react-pdf/renderer';
import { defaultTemplate } from 'core/hoc';
import _ from 'lodash';
import moment from 'moment';
import { tempImagePlaceholder } from 'common/constants';

function PicklistPDFTemplate(props) {
	const { data, t, onRender, pickingBatchId } = props;

	const currentDayDateAndTime = moment().format('dddd, MMMM DD, YYYY, hh:mm A');

	const styles = {
		body: {
			padding: 24,
		},

		header: {
			width: '100%',
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'space-between',
			marginBottom: 15,
		},

		headerTitle: {
			fontSize: 20,
		},

		batchTitle: {
			fontSize: 15,
			marginBottom: 10,
		},

		headerText: {
			fontSize: 12,
			textTransform: 'capitalize',
		},

		table: {
			display: 'table',
			fontSize: 8,
			textAlign: 'left',
			borderStyle: 'solid',
			borderColor: '#D0D0D0',
			borderLeftWidth: 1,
			borderBottomWidth: 1,
		},

		tableRow: {
			flexDirection: 'row',
		},

		tableColHeader: {
			width: '25%',
			borderStyle: 'solid',
			borderColor: 'rgb(31, 72, 82)',
			borderRightWidth: 1,
			backgroundColor: '#1E5C6A',
		},

		tableCol: {
			width: '25%',
			borderStyle: 'solid',
			borderColor: '#D0D0D0',
			borderRightWidth: 1,
			borderTopWidth: 1,
			borderBottomWidth: 1,
		},

		tableColFull: {
			width: '100%',
			backgroundColor: '#F5F5F5',
			borderStyle: 'solid',
			borderColor: '#D0D0D0',
			borderRightWidth: 1,
		},

		tableCellHeader: {
			padding: 6,
			color: '#fff',
		},

		tableCell: {
			padding: 6,
			display: 'block',
			marginTop: 'auto',
			marginBottom: 'auto',
		},

		tableCellRequired: {
			display: 'block',
			textAlign: 'center',
			marginTop: 'auto',
			marginBottom: 'auto',
			fontSize: 14,
			fontWeight: 'bold',
			padding: 6,
		},

		imageCell: {
			width: '30%',
			textAlign: 'center',
			display: 'block',
			justifyContent: 'center',
			alignItems: 'center',
			margin: 'auto',
		},

		tableCellFull: {
			padding: 6,
		},
	};
	return (
		<PDFViewer id="pdf-print" name="pdf-print" style={{ display: 'none' }}>
			<Document onRender={pdfBlob => onRender(pdfBlob)}>
				<Page style={styles.body} size="A4">
					<View style={styles.header}>
						<Text style={styles.headerTitle}>{t('FULFILLMENTORDER.PICKINGBATCH.PDF.TITLE')}</Text>
						<Text style={styles.headerText}>{currentDayDateAndTime}</Text>
					</View>
					<Text style={styles.batchTitle}>
						{`\n${t('FULFILLMENTORDER.PICKINGBATCH.PDF.BATCHID')}: ${pickingBatchId}`}
					</Text>
					<View style={styles.table}>
						<View style={styles.tableRow}>
							<View style={styles.tableColHeader}>
								<Text style={styles.tableCellHeader}></Text>
							</View>
							<View style={styles.tableColHeader}>
								<Text style={styles.tableCellHeader}>{t('FULFILLMENTORDER.PICKINGBATCH.PDF.ITEMSKU')}</Text>
							</View>
							<View style={styles.tableColHeader}>
								<Text style={styles.tableCellHeader}>{t('FULFILLMENTORDER.PICKINGBATCH.PDF.PRODUCTNAME')}</Text>
							</View>
							<View style={styles.tableColHeader}>
								<Text style={styles.tableCellHeader}>{t('FULFILLMENTORDER.PICKINGBATCH.PDF.REQUIRED')}</Text>
							</View>
						</View>
						{_.map(data, (item, idx) => {
							return (
								<React.Fragment key={idx}>
									<View style={styles.tableRow}>
										<View style={styles.tableCol}>
											<Image style={styles.imageCell} src={tempImagePlaceholder.source} />
										</View>
										<View style={styles.tableCol}>
											<Text style={styles.tableCell}>{item.product.sku}</Text>
										</View>
										<View style={styles.tableCol}>
											<Text style={styles.tableCell}>{item.product.name}</Text>
										</View>
										<View style={styles.tableCol}>
											<Text style={styles.tableCellRequired}>{item.orders.length}</Text>
										</View>
									</View>
									<View style={styles.tableRow}>
										<View style={styles.tableColFull}>
											<Text style={styles.tableCellFull}>
												Orders:{' '}
												{_.map(item.orders, (orderNumber, idxInner) => {
													if (idxInner === item.orders.length - 1) {
														return orderNumber;
													}
													return orderNumber + ' | ';
												})}
											</Text>
										</View>
									</View>
								</React.Fragment>
							);
						})}
					</View>
				</Page>
			</Document>
		</PDFViewer>
	);
}

export default defaultTemplate(PicklistPDFTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/PicklistPDFTemplate.jsx